/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Testimonials_TitleInputs */

const en_why_listening_testimonials_title = /** @type {(inputs: Why_Listening_Testimonials_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`They tried the others first.`)
};

const es_why_listening_testimonials_title = /** @type {(inputs: Why_Listening_Testimonials_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probaron las demás primero.`)
};

/**
* | output |
* | --- |
* | "They tried the others first." |
*
* @param {Why_Listening_Testimonials_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_testimonials_title = /** @type {((inputs?: Why_Listening_Testimonials_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Testimonials_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_testimonials_title(inputs)
	return en_why_listening_testimonials_title(inputs)
});